interface SpacerProps {
  size?: 'sm' | 'md' | 'lg';
}

export function Spacer({ size = 'md' }: SpacerProps) {
  const classes = {
    sm: 'h-4 md:h-8',
    md: 'h-8 md:h-16',
    lg: 'h-16 md:h-32',
  };

  return <div className={classes[size]} />;
}
